/**
 * Width + radius for centered dialogs. Mobile gutters come from @crowdfpl/ui-web DialogContent defaults
 * (`w-[calc(100vw-2rem)]`). Use this helper when a modal needs a custom max-width cap.
 */
export const dialogContentResponsive = 'max-w-lg rounded-2xl sm:rounded-2xl';
